import { translations } from '@tools/translations/translations';
import { forEach } from 'lodash-es';

export const initEditOffer = () => {
  if (!document.querySelector('.edit-offer-title')) {
    return;
  }

  let formHasChanged = false;

  // Dispatch a custom event to the form and avoid tight coupling as we need to monitor changes in custom elements too
  // (i.e. rich text of description step for example)
  function inputChangeHandler() {
    let event;
    if (typeof Event === 'function') {
      event = new Event('editFormChanged');
    } else {
      // Damn IE
      event = document.createEvent('Event');
      event.initEvent('editFormChanged', true, true);
    }
    document.forms.setup?.dispatchEvent(event);
  }

  function formChangedHandler() {
    const submitBtn = document.querySelector('#setup_submit');
    if (submitBtn) {
      submitBtn.disabled = false;
      formHasChanged = true;
    }
  }

  function leaveAlert(event) {
    if (!formHasChanged) {
      return;
    }
    const unloadEvent = event || window.event;

    // For IE and Firefox. Message is only displayed
    // for older versions of browser. Newer have built-in message
    if (unloadEvent) {
      unloadEvent.returnValue = translations.messages[
        'form.offer.unsaved_changes'
      ];
      return;
    }

    // For Safari. Message is only displayed
    // for older versions of browser. Newer have built-in message
    // eslint-disable-next-line consistent-return
    return translations.messages['form.offer.unsaved_changes'];
  }

  /**
   * Without this timeout, we cannot display properly the alert "Unsaved changes" on the edit offer view.
   * @see https://bureaux-a-partager.atlassian.net/browse/MATCH-5676
   */
  async function editOffer() {
    await new Promise((r) => {
      setTimeout(r, 1000);
    });
    if (document.querySelector('.edit-offer-title')) {
      const isOnIOS = navigator.userAgent.match(/iPad/i)
        || navigator.userAgent.match(/iPhone/i)
        || navigator.userAgent.match(/iPod/i);

      if (!isOnIOS) {
        window.onbeforeunload = leaveAlert;
      }
      const h1 = document.querySelector('.edit-offer-title h1 span');
      const navSelect = document.querySelector('.edit-offer-title select');

      navSelect.addEventListener('change', () => {
        h1.innerHTML = navSelect.options[navSelect.selectedIndex].innerHTML;
        if (isOnIOS && formHasChanged) {
          // eslint-disable-next-line no-alert
          const retVal = window.confirm(
            translations.messages['form.offer.unsaved_changes'],
          );
          if (retVal) {
            document.location.href = navSelect.value;
          }
          return;
        }
        document.location.href = navSelect.value;
      });

      const formInputs = document.querySelectorAll(
        '.create-offer input, .create-offer select',
      );
      forEach(formInputs, (item) => {
        item.onchange = inputChangeHandler; // eslint-disable-line no-param-reassign
      });

      const submitBtn = document.querySelector('#setup_submit');
      document.forms.setup?.addEventListener('submit', () => {
        submitBtn.disabled = true;
        formHasChanged = false;
      });
      document.forms.setup?.addEventListener(
        'editFormChanged',
        formChangedHandler,
      );
    }
  }

  editOffer();
};
